import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateCompanyUser($companyId: ID!, $attributes: CompanyUserAttributes!) {
    createCompanyUser(companyId: $companyId, attributes: $attributes) {
      companyUser {
        id
        ...CreatedCompanyUser
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedCompanyUser on CompanyUser {
    id
    user { id name }
    acceptedAt
    initiatedBy { id name }
    role
  }
`
